import { useQuery } from '@tanstack/react-query';
import { publicApi } from '@/lib/api';
import type { Setting } from '@/types';

export function usePublicSettings() {
  return useQuery({
    queryKey: ['public-settings'],
    queryFn: async () => (await publicApi.settings.get()).data as Setting,
    staleTime: 5 * 60 * 1000,
  });
}
